._DaysRelative_1ms8f_1 {
  text-align: right;
}